import fetch from '../../../utils/fetch'

const initialState = {
  isLoading: false,
  error: '',
  created: null,
  projectHistory: null,
}

const getters = {
  isLoading(state) {
    return state.isLoading
  },
  projectHistory(state) {
    return state.projectHistory
  },
  error(state) {
    return state.error
  },
}

const actions = {

  getSciStarterHistory({commit}, data) {
    commit(types.SCISTARTER_HISTORY_ERROR, '')
    commit(types.SCISTARTER_HISTORY_LOADING)

    return fetch('/projects/' + data.projectId + '/project_scistarter_history' + data.urlParams)
      .then(response => response.json())
      .then((data) => {
        commit(types.SCISTARTER_PROJECT_HISTORY, data['hydra:member'])
        return data
      })
      .catch((error) => {
        commit(types.SCISTARTER_HISTORY_ERROR, error)
      })
  },
}


const types = {
  SCISTARTER_HISTORY_LOADING: 'SCISTARTER_HISTORY_LOADING',
  SCISTARTER_HISTORY_ERROR: 'SCISTARTER_HISTORY_ERROR',
  SCISTARTER_PROJECT_HISTORY: 'SCISTARTER_PROJECT_HISTORY',
  RESET: 'RESET',
}

const mutations = {
  [types.SCISTARTER_HISTORY_LOADING](state) {
    state.isLoading = true;
  },
  [types.SCISTARTER_HISTORY_ERROR](state, error) {
    state.errors = error;
    state.isLoading = false;
  },
  [types.SCISTARTER_PROJECT_HISTORY](state, data) {
    state.projectHistory = data
    state.isLoading = false
  },
  [types.RESET](state) {
    state = initialState
  },
}

export default {
  namespaced: true,
  state: initialState,
  getters: getters,
  actions: actions,
  mutations: mutations
}

